import { useEffect, useState } from "react";

function Toast() {
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setMessage(e.detail.message);
      setShow(true);

      setTimeout(() => {
        setShow(false);
      }, 3000);
    };

    window.addEventListener("showToast", handler);
    return () => window.removeEventListener("showToast", handler);
  }, []);

  if (!show) return null;

  return <div className="toast">{message}</div>;
}

export default Toast;